import React from "react"
import Layout from "../components/Layout"
import SEO from '../components/SEO'

const contact = () => {
  return (
    <Layout>
      <SEO title="Contact Me" description="Will try to reply"/>
      <section className="contact-page">
        <article className="contact-form">
          <h3>Get in touch</h3>
          <form action="https://formspree.io/mrgywkya" method="POST">
            <div className="form-group">
              <input
                className="form-control"
                placeholder="name"
                name="name"
                type="text"
              />
              <input
                className="form-control"
                placeholder="email"
                type="email"
                name="email"
              />
              <textarea
                name="message"
                rows="4"
                placeholder="message"
                className="form-control"
              />
            </div>
            <button type="submit" className="submit-btn btn">
              Submit
            </button>
          </form>
        </article>
      </section>
    </Layout>
  )
}

export default contact
